import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/de'
import { DateSelectType, TimeSelectType } from '@/components/TVProgram/types'

export const getDates = (): DateSelectType[] => {
    const dates = []
    let i
    // add yesterday, today and the next 40 days to the dates list
    for (i = 0; i < 9; i++) {
        let date: Dayjs
        let namePrefix = ''
        if (i === 0) {
            namePrefix = 'Gestern '
            date = dayjs().subtract(1, 'day')
        } else if (i === 1) {
            namePrefix = 'Heute '
            date = dayjs()
        } else if (i === 2) {
            namePrefix = 'Morgen '
            date = dayjs().add(1, 'day')
        } else {
            date = dayjs().add(i - 1, 'day')
        }
        dates.push({
            label: `${namePrefix}${date.tz().format('dd., DD.MM.')}`,
            value: {
                id: `${i}`,
                date:
                    i === 1
                        ? date.toISOString()
                        : date.set('hour', 15).set('minute', 0).toISOString(),
            },
        })
    }
    return dates
}

export const getHours = (isToday?: boolean): TimeSelectType[] => [
    ...(isToday
        ? [
              {
                  label: 'Jetzt',
                  value: {
                      id: '0',
                      lookbackHours: 24,
                  },
              },
          ]
        : [
              {
                  label: 'Tagesansicht',
                  value: {
                      id: '0',
                      hour: 15,
                      minute: 0,
                      lookbackHours: 18,
                  },
              },
          ]),
    {
        label: 'Vormittag / Mittag',
        value: {
            id: '1',
            hour: 6,
            minute: 0,
            lookbackHours: 9,
        },
    },
    {
        label: 'Nachmittag',
        value: {
            id: '2',
            hour: 15,
            minute: 30,
            lookbackHours: 18,
        },
    },
    {
        label: 'Abend',
        value: {
            id: '3',
            hour: 20,
            minute: 15,
            lookbackHours: 24,
        },
    },
    {
        label: 'Nacht',
        value: {
            id: '4',
            hour: 0,
            minute: 0,
            lookbackHours: 12,
        },
    },
    ...new Array(24).fill(24).map((entry, index) => {
        return {
            label: `${index}:00`,
            value: {
                id: `${5 + index}`,
                hour: index,
                minute: 0,
                lookbackHours: index + 3,
            },
        }
    }),
]
